
import HotItems from '../hotItems/HotItems';
import * as homeStyle from '../homePage/style.css';
import ProductsSlider from '../../../components/productsSlider/ProductsSlider';
import React = require('react');

export default class HotHits extends HotItems {
    renderView() {
        return (<div className={homeStyle.hotItems}>

            <div className={homeStyle.sectionTitle} >
                {this.props.title}
            </div>
            <div className={homeStyle.sectionBar}></div>
            {this.state.models.length > 0 &&
            <ProductsSlider
                models={this.state.models}
                buyClick={(id, name) => this.handleItemBuy(id, name)}
            />
            }
        </div>);
    }
}
